<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header" style="padding: 0px !important">
                <div class="page-breadcrumb">
                    <div class="row">
                        <div class="col-5 align-self-center">
                            <h4 class="page-title">{{ $t("lang.label_mt") }}</h4>
                        </div>
                        <div class="col-7 align-self-center">
                            <div class="d-flex align-items-right justify-content-end">
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item">
                                            <router-link
                                                :to="{ name: 'Setup' }"
                                                class="btn btn-info btn-sm mr-2"
                                            >
                                                <i class="fas fa-arrow-left"></i>
                                                {{ $t("lang.label_back") }}
                                            </router-link>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="load" v-if="isloading"><loader></loader></div>
                <div class="row" v-else>
                    <div class="col-md-6">
                        <form class="form-rest" @submit.prevent="SaveMetaTags">
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="title"
                                        >{{ $t("lang.label_title") }}:
                                        <small
                                            >({{ $t("lang.label_maxr_caracter") }})</small
                                        ></label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="title"
                                        v-model="f.title"
                                        maxlength="100"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="keywords"
                                        >{{ $t("lang.label_keywords") }}:</label
                                    >
                                    <textarea
                                        class="form-control"
                                        id="keywords"
                                        rows="2"
                                        v-model="f.keywords"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="description"
                                    >{{ $t("lang.label_description") }}:
                                    <small
                                        >({{ $t("lang.label_max_caracter") }})</small
                                    ></label
                                >
                                <textarea
                                    class="form-control"
                                    id="description"
                                    rows="4"
                                    v-model="f.description"
                                    maxlength="155"
                                ></textarea>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="inputZip"
                                            >{{ $t("lang.label_poster") }}:</label
                                        >
                                        <input
                                            type="file"
                                            class="form-control-file img_logo"
                                            id="img_logo"
                                            name="img_logo"
                                            v-on:change="uploadFile"
                                            ref="logo"
                                            accept="image/jpeg,image/jpg"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-6">
                                    <div class="form-row">
                                        <div
                                            class="d-flex justify-content-between align-items-end"
                                        >
                                            <div class="inputs_fb">
                                                <label for="inputCity"
                                                    >Facebook Like:</label
                                                >
                                            </div>
                                            <div class="inputs_swich">
                                                <div class="onoffswitch">
                                                    <input
                                                        type="checkbox"
                                                        name="onoffswitch"
                                                        class="onoffswitch-checkbox"
                                                        id="myonoffswitch1"
                                                        tabindex="0"
                                                        v-model="f.fb_like"
                                                        :checked="f.fb_like"
                                                    />
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="myonoffswitch1"
                                                    >
                                                        <span
                                                            class="onoffswitch-inner"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch"
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-row">
                                        <div
                                            class="d-flex justify-content-between align-items-end"
                                        >
                                            <div class="inputs_fb">
                                                <label for="inputCity"
                                                    >Facebook Comments:</label
                                                >
                                            </div>
                                            <div class="inputs_swich">
                                                <div class="onoffswitch">
                                                    <input
                                                        type="checkbox"
                                                        name="onoffswitch01"
                                                        class="onoffswitch-checkbox"
                                                        id="onoffswitch01"
                                                        tabindex="0"
                                                        v-model="f.fb_comments"
                                                        :checked="f.fb_comments"
                                                    />
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="onoffswitch01"
                                                    >
                                                        <span
                                                            class="onoffswitch-inner"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch"
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input type="hidden" v-model="f.id" />
                            <div
                                class="d-flex align-items-center justify-content-center"
                                style="margin-top: 20px"
                            >
                                <button
                                    type="submit"
                                    class="btn btn-success"
                                    :disabled="btndisable"
                                >
                                    {{ btnName }}
                                </button>
                            </div>
                            <br />
                        </form>
                    </div>
                    <div class="col-md-6">
                        <div class="thumbnail poster-fb" v-if="f.title.length > 0">
                            <div v-bind:class="[{ noneImg: is_filel === false }, '']">
                                <div class="btns_action">
                                    <button
                                        @click="deleteImage"
                                        class="btn btn-danger deleteImg"
                                    >
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                                <img :src="url" alt="poster" style="width: 100%" />
                            </div>
                            <div class="caption">
                                <h4 class="title">{{ f.title }}</h4>
                                <p class="description">{{ f.description }}</p>
                                <p class="urlperfil">
                                    <a :href="urlRestaurant" target="blank">{{
                                        web_name
                                    }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="noti" position="top center"></notifications>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import axios from "axios";
export default {
    name: "MetaTags",
    components: {
        Loader,
    },
    data () {
        return {
            btndisabled: false,
            btndisable: false,
            btnName: window.lang2.label_save,
            isloading: false,
            search: "",
            web: window.urlweb,
            web_name: "",
            urlRestaurant: "",
            f: {
                id: 0,
                user_id: window.localAccountID,
                org_id: window.localorgdata,
                title: "",
                keywords: "",
                description: "",
                fb_comments: 0,
                fb_like: 0,
                is_filel: false,
                poster: null,
                posterOld: null,
            },
            url: "",
        };
    },
    created () {
        this.getMetaTags();
        this.web_name = this.web.replace("https://", "").replace("/", "");
    },
    methods: {
        getMetaTags() {
            this.isLoading = true;
            window.master
                .post("/metatags/get", this.f)
                .then((response) => {
                    let result = response.data.result;
                    let rs = response.data.res;
                    let name = '';
                    if (rs !== null) {
                        name = rs.name;
                    }
                    this.is_filel = response.data.is_filel;
                    if (result !== null) {
                        this.f.poster =
                            result.poster === null || result.poster === "null"
                                ? null
                                : result.poster;
                        this.url = response.data.url + this.f.poster;
                        this.f.posterOld = response.data.old;
                        if (result.title !== null || result.title !== "") {
                            this.f.title = result.title;
                        } else {
                            this.f.title = name;
                        }
                        if (result.description !== null) {
                            this.f.description = result.description;
                        } else {
                            this.f.description = rs.description;
                        }
                        this.urlRestaurant = this.web + rs.url;
                        this.f.keywords = result.keywords;
                        this.f.fb_comments = result.fb_comments;
                        this.f.fb_like = result.fb_like;
                        this.f.id = result.id;
                    } else {
                        this.f.title = name;                       
                        this.f.fb_comments = 0;
                        this.f.fb_like = 0;
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.log(error);
                });
        },
        uploadFile(e) {
            var o = document.getElementById("img_logo");
            var foto = o.files[0];
            if (o.files.length === 0 || !/\.(jpg|png)$/i.test(foto.name)) {
                this.$notify({
                    group: "noti",
                    title: "ERROR",
                    type: "error",
                    text: window.lang2.label_fimage,
                });
                return false;
            } else {
                this.f.poster = e.target.files[0];
            }
        },
        SaveMetaTags() {
            this.btndisable = true;
            this.isloading = true;
            if (this.f.fb_comments === true) {
                this.f.fb_comments = 1;
            } else {
                this.f.fb_comments = 0;
            }
            if (this.f.fb_like === true) {
                this.f.fb_like = 1;
            } else {
                this.f.fb_like = 0;
            }
            let fileSendHeader = {
                headers: { "Content-Type": "multipart/form-data" },
            };          
            let formData = new FormData();
            formData.append("id", this.f.id);
            formData.append("user_id", this.f.user_id);
            formData.append("org_id", this.f.org_id);
            formData.append("title", this.f.title);
            formData.append("keywords", this.f.keywords);
            formData.append("description", this.f.description);
            formData.append("fb_comments", this.f.fb_comments);
            formData.append("fb_like", this.f.fb_like);
            formData.append("poster", this.f.poster);
            formData.append("posterOld", this.f.posterOld);
            let url = "/metatags/add";
            window.master
                .post(url, formData, fileSendHeader)
                .then((response) => {
                    if (response.data.status === false) {
                        this.$notify({
                            group: "noti",
                            title: "ERROR",
                            type: "error",
                            text: window.lang2.label_tm,
                        });
                    }
                    this.getMetaTags();
                    this.btndisable = false;
                    this.isloading = false;
                })
                .catch((error) => {
                    this.btndisable = false;
                    this.isLoading = false;
                });
        },
        deleteImage() {
            this.$swal({
                title: window.lang2.label_del_img + "?",
                // text: window.lang2.label_del_img+'?',
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    this.btndisabled = true;
                    window.master
                        .post("/metatags/del", this.f)
                        .then((response) => {
                            let result = response.data;
                            console.log(result);
                            this.getMetaTags();
                            this.isLoading = false;
                            this.btndisabled = false;
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            this.btndisabled = false;
                            console.log(error);
                        });
                }
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.form-rest {
    .form-control {
        border: 1px solid #bfbfbf;
    }
    .form-group {
        margin-bottom: 0.5rem;
    }
}
.onoffswitch {
    position: relative;
    width: 83px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
.onoffswitch-checkbox {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid #ffffff;
    border-radius: 25px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 26px;
    padding: 0;
    line-height: 26px;
    font-size: 13px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "Público";
    padding-left: 8px;
    background-color: #82c234;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Privado";
    padding-right: 8px;
    background-color: #eeeeee;
    color: #999999;
    text-align: right;
}
.onoffswitch-switch {
    display: block;
    width: 18px;
    margin: 4px;
    background: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 53px;
    border: 2px solid #ffffff;
    border-radius: 25px;
    transition: all 0.3s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
.vue-notification-group {
    top: 60px !important;
}
.title {
    margin-bottom: 0px;
    font-weight: 900;
    font-size: 21px;
    color: #4f5467;
}
.description {
    margin-bottom: 0px;
    font-size: 13px;
    color: #212529;
}
p.urlperfil {
    margin-bottom: 0px;
}
p.urlperfil a {
    color: #bcbdc1;
    text-transform: uppercase;
    text-decoration: none;
}
.thumbnail.poster-fb {
    max-width: 500px;
    margin: 0px auto;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 4px;
}
.thumbnail.poster-fb img {
    border-radius: 4px;
    margin-bottom: 5px;
}
.noneImg {
    display: none;
}
.btns_action {
    display: flex;
    position: absolute;
    button {
        cursor: pointer;
        border-radius: 4px;
    }
}

.deleteImg {
    position: absolute;
    top: 0;
    left: 0;
    padding: 4px 8px;
    font-size: 10px;
    transition: 0.15s padding ease-out, 0.15s margin ease-out, 0.15s border ease-out;
}
</style>
